import React from 'react';
import { TreeNodeType } from 'src/lib/types/types';
import { MATreeStructureAbschluss } from '../default-content/abschluss-seite/MATreeStructureAbschluss';
import { TreeStructureAnlagenMA } from '../default-content/anlagen/TreestructureAnlagenMA';
import { TreeStructureErklaerungMA } from '../default-content/erklaerung/TreestructureErklaerungMA';
import { getFormStrucStammdatenblattMA } from '../default-content/stammdatenblatt/content/StammdatenblattMA';
import { TreeStructureWichtigeHinweiseMA } from '../default-content/wichtige-hinweise/TreeStructureWichtigeHinweiseMA';
import BescheidDatenMAStipendium from './content/BescheidDatenMAStipendium';
import { MittelabrufStipendium } from './content/MittelabrufStipendium';
import { getFormstrucProjektausgabenMAStipendium, ProjektausgabenMAStipendium } from './content/ProjektausgabenMAStipendium';
import ProjektDatenMAStipendium from './content/ProjektdatenMAStipendium';

export const TreeStructureMAStipendium = (application: any) => {
	let treeNodes: TreeNodeType[] = [
		...TreeStructureWichtigeHinweiseMA(application),
		{
			label: 'Projektdaten',
			content: <ProjektDatenMAStipendium />,
			formStruc: getFormStrucStammdatenblattMA(application),
		},
		{
			label: 'Übersicht Bewilligung',
			content: <BescheidDatenMAStipendium />,
		},
		{
			label: 'Projektausgaben',
			content: <ProjektausgabenMAStipendium />,
			formStruc: getFormstrucProjektausgabenMAStipendium(application),
		},
		{
			label: 'Mittelabruf',
			content: <MittelabrufStipendium />,
		},
		...TreeStructureAnlagenMA(application),
		...TreeStructureErklaerungMA(application),
		...MATreeStructureAbschluss(application),
	];

	return treeNodes;
};
